import { Typography, TypographyProps } from "@mui/material";

interface IProps extends TypographyProps {
  title: string;
}

const StepperMarks: React.FC<IProps> = ({ title, ...props }) => {
  return (
    <Typography
      px={2}
      py={0.75}
      bgcolor="background.default"
      width="fit-content"
      mx="auto"
      borderRadius={25}
      variant="subtitle1"
      fontWeight={{ xs: 700, md: 600 }}
      {...props}
    >
      {title}
    </Typography>
  );
};

export default StepperMarks;
